import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#4CAF50', cx: '12', cy: '12', r: '12' }),
    React.createElement("path", { key: '1', fill: '#FFFFFF', d: 'M16,8.9h-0.6V7.6c0-1.9-1.5-3.3-3.3-3.3S8.7,5.8,8.7,7.6v1.3H7.9c-0.7,0-1.3,0.6-1.3,1.3v6.7\n\tc0,0.7,0.6,1.3,1.3,1.3h8c0.7,0,1.3-0.6,1.3-1.3v-6.7C17.4,9.6,16.8,8.9,16,8.9z M12,15c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3\n\ts1.3,0.6,1.3,1.3C13.3,14.3,12.7,15,12,15z M14.1,8.9H9.9V7.6c0-1.2,0.9-2.1,2.1-2.1s2.1,0.9,2.1,2.1V8.9z' }),
], 'TransportConditionLockSuccess');
const TransportConditionLockSuccessIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportConditionLockSuccessIcon);
